import SearchParamsBase from '../../../Elements/SearchParamsBase';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import dateTimeHelper from '../../../Helpers/datetimeHelper';

export default class FraudHitEvaluatorSearchParams extends SearchParamsBase {
  static iconName = 'fa-solid fa-search';
  static saveType = 'FraudHitEvaluatorSearchParams';

  initialize(recordId) {
    this.RecordId = recordId;
    // No fraud statuses pre-selected — business asked for the unfiltered list by default (CD-5384).
    this.SelectedFraudStatuses = [];
    this.StatusChangeDate = dateTimeHelper.toYYYYsMMsDD(dateTimeHelper.indefiniteDateValue());
  }

  static fieldsInSearchBox = [
    { fieldName: 'ShopperId', label: 'Shopper ID', className: 'col-4', type: InputTypesEnum.Number },
    { fieldName: 'ShopperName', label: 'Shopper Name', className: 'col-4', type: InputTypesEnum.Text },
    {
      fieldName: 'SelectedAccountStatuses',
      label: 'Account Status',
      className: 'col-4',
      type: InputTypesEnum.LookupMultiChoice,
      options: 40,
    },
    { fieldName: 'ProfileEmail', label: 'Profile Email', className: 'col-4', type: InputTypesEnum.Text },
    {
      fieldName: 'SelectedFraudStatuses',
      label: 'Fraud Status',
      className: 'col-4',
      type: InputTypesEnum.MultiChoice,
      options: [
        { value: 'Detected', label: 'Detected' },
        { value: 'Under Investigation', label: 'Under Investigation' },
        { value: 'Cleared', label: 'Cleared' },
        { value: 'Confirmed Fraud', label: 'Confirmed Fraud' },
        { value: 'Confirmed Deactivated', label: 'Confirmed & Deactivated' },
      ],
    },
    {
      fieldName: 'SelectedFieldowrkOfficeIds',
      // label: 'FW Office',
      label: 'Ev. Pym Office',
      className: 'col-4',
      type: InputTypesEnum.OfficeOrGroupMultiSelect,
    },
    {
      fieldName: 'SelectedCountries',
      label: 'Country',
      className: 'col-4',
      type: InputTypesEnum.CountryCodeMultiChoice,
    },
    { fieldName: 'PendingOnId', label: 'Pending On', className: 'col-4', type: InputTypesEnum.UserSelect },
    {
      fieldName: 'StatusChangeDate',
      label: 'StatusChangeDate',
      className: 'col-4',
      type: InputTypesEnum.DateWithIndefinite,
    },
  ];
}
